(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restoration-contact-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restoration-contact-gallery')) {
    class RestorationContactGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.restoration-contact-gallery__track');
        this.previousButton = this.querySelector('[data-action="previous"]');
        this.nextButton = this.querySelector('[data-action="next"]');
        this.slideCount = this.querySelectorAll('.restoration-contact-gallery__slide').length;
        this.currentIndex = 0;

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.update();
      }

      goTo(index) {
        const boundedIndex = Math.max(0, Math.min(index, this.slideCount - 1));
        if (boundedIndex === this.currentIndex) return;
        this.currentIndex = boundedIndex;
        this.update();
      }

      update() {
        this.track?.style.setProperty('--gallery-index', String(this.currentIndex));

        if (this.previousButton) {
          this.previousButton.disabled = this.currentIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled = this.currentIndex === this.slideCount - 1;
        }
      }
    }

    customElements.define('restoration-contact-gallery', RestorationContactGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
